(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('OnuData', OnuData);

    OnuData.$inject = ['$rootScope', 'RequestService'];

    function OnuData($rootScope, RequestService) {

        return {
            triggerItemAuthorized: function (data) {
                $rootScope.$broadcast('onuNewItemAuthorized', data);
            },
            triggerItemAuthorizedWithStatus: function (data) {
                $rootScope.$broadcast('getOnuStatus', data);
            },
            parseOnu: function (item) {
                item.statusGpon = item.statusGpon ? item.statusGpon.toLowerCase() : '--';
                item.rxPower = item.rxPower ? item.rxPower.toFixed(1) : '--';
                item.txPower = item.txPower ? item.txPower.toFixed(1) : '--';
                item.softwareVersion = item.softwareVersion ? item.softwareVersion : '--';
                if (!item.mostCriticalAlarm || item.mostCriticalAlarm == 'NONE') {
                    item.mostCriticalAlarm = '';
                }
                item.mostCriticalAlarm = item.mostCriticalAlarm.toLowerCase();
                return item;
            },
            isSearch: false,
            setSearch: function (isSearch) {
                this.isSearch = isSearch;
            },
            search: function (searchData) {
                for (var key in searchData) {
                    if (!searchData[key]) {
                        delete searchData[key];
                    }
                }
                $rootScope.$broadcast('onuSearch', searchData);
            }
        };
    }
})();